import { Injectable, HostListener } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { User } from "./views/common/models/user_model";
import { Proofcard } from "./views/common/models/proofcard_model";
import * as CryptoJS from "crypto-js";
import { Router } from "@angular/router";
import { CommonService } from "./views/common/services/common.service";

@Injectable()
export class SessionService {
  //Manual Passsword for encryption and descrytion using AES Cryptojs
  tag_key: String = "15l!VF!ve_P15rtr@!t19";

  constructor(
    private http: HttpClient,
    private route: Router,
    private commonServ: CommonService
  ) {}
  setHeader() {
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/json; charset=utf-8");
    return headers;
  }
  myHeaders = this.setHeader();

  getProofCardAccess(bodyParams: Proofcard) {
    let url = environment.URL + "/proofcardAccess";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  requestToMigrateproofcard(bodyParams) {
    let url = environment.URL + "/oldWebsiteProofcard";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  getAccessCodeLogin(bodyParams) {
    let url = environment.URL + "/accessCodeLogin";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  getAccountLogin(bodyParams: User) {
    let url = environment.URL + "/login";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  getalllogin(bodyParams) {
    let url = environment.URL + "/allLogin";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  loginWithEmailOnly(bodyParams) {
    let url = environment.URL + "/customerLoginWithEmailOnly";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }


  getVerifyManagerLogin(token) {
    let url = environment.URL + "/verifyManagerToken/" + token;
    return this.http.get(url, { headers: this.myHeaders });
  }

  // verifyAccount(token) {
  //   let url = environment.URL + "/verifyToken/" + token;
  //   return this.http.get(url, { headers: this.myHeaders });
  // }

  verifyAccount(token) {
    let url = environment.URL + "/verifyPasswprdToken/" + token;
    return this.http.get(url, { headers: this.myHeaders });
  }

  verifyEmail(email, password) {
    let bodyParams = {
      email: email,
      password: password
    };
    let url = environment.URL + "/verifyEmail";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  getCustomerLogin(bodyParams) {
    let url = environment.URL + "/customerLogin";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  getCustomerRegistration(bodyParams) {
    let url = environment.URL + "/customerRegistration";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  resetCustomerPassword(bodyParams) {
    let url = environment.URL + "/updatePassword";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  resetPassword(bodyParams) {
    let url = environment.URL + "/updatePasswordForAll";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }


  // sendResetPasswordLink(email, isCheckout, sessionId) {
  //   let url =
  //     environment.URL +
  //     "/forgotPassword/" +
  //     email +
  //     "/" +
  //     isCheckout +
  //     "/" +
  //     sessionId;
  //   return this.http.get(url, { headers: this.myHeaders });
  // }

  sendResetPasswordLink(email, isCheckout, sessionId) {
    let url =
      environment.URL +
      "/allForgotPassword/" +
      email +
      "/" +
      isCheckout +
      "/" +
      sessionId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  LinkProofcardToCustomerAccount(bodyParams) {
    let url = environment.URL + "/linkProofcard";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  getProofcardAccesByCode(accessCode) {
    let url = environment.URL + "/getProofcardId/" + accessCode;
    return this.http.get(url, { headers: this.myHeaders });
  }

  setAuthToken(accessToken) {
    if (accessToken != null) {
      let encryptedData: any = CryptoJS.AES.encrypt(
        `${accessToken}`,
        this.tag_key
      );

      sessionStorage.setItem("AccessKey", encryptedData);
    }
  }

  logout(value) {
    let url = environment.URL + "/logout";
    this.http.get(url, { headers: this.myHeaders }).subscribe((res: any) => {
      if (value == true) {
        sessionStorage.clear();
        localStorage.clear();
      }
    });
  }

  customerLogout() {
    let url = environment.URL + "/logout";
    return this.http.get(url, { headers: this.myHeaders });
  }
}
